import React, { useState } from "react";
import { Form, Col, Row, Card, Button, Modal, Badge, Spinner } from 'react-bootstrap';
import styles from './ReportItineraryVesselSummary.module.scss';
import { t } from "i18next";
import Lottie from 'react-lottie';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import it from 'date-fns/locale/it';

//general
import UserClass from "../../../General/LocalStorage/UserClass";
import DataManager from "../../../General/DataManager";
import Functions from "../../../General/Functions";
import reportTicket from "../../../assets/animation/animation_report.json";
import { arr_mode_system, arr_type_report } from "../../../config/constants";

const ReportItineraryVesselSummary = props => {

    const defaultOptionsReport = {
        loop: true,
        autoplay: true,
        animationData: reportTicket
    };
    const [company, setCompany] = useState("");
    const [dateFrom, setDateFrom] = useState(null);
    const [companies, setCompanies] = useState([])
    const [Trips, setTrips] = useState([])
    const [showModalFilter, setShowModalFilter] = useState(false);
    const [reset, setReset] = useState(false);
    const [dateOfDay, setDateOfDay] = useState("");
    const [dateOfMonth, setDateOfMonth] = useState(null);
    const [typologyReport, setTypologyReport] = useState("");
    const [totFilter, setTotFilter] = useState(0);
    const [arrFilter, setArrFilter] = useState(null);
    const [showModalFilterRaceSummary, setshowModalFilterRaceSummary] = useState(false);
    const [msgModalReport, setMsgModalReport] = useState("");
    const [showTrip, setShowTrip] = useState(true);
    const [showSpinner, setShowSpinner] = useState(true)
    const [reportPdf, setReportPdf] = useState(null);
    const [pdfChecked, setpdfChecked] = useState(true);
    const [csvChecked, setcsvChecked] = useState(false);
    const [Document, setDocument] = useState(null)
    const [csvDocument, setDocumentCSV] = useState(null)
    const [showCompany, setshowCompany] = useState(true)
    const [disableButton, setDisableButton] = useState(true)
    const [showDocument, setshowDocument] = useState(true)
    const [selectedFilter, setSelectedFilter] = useState('DEPARTUREDATE');
    const [ports, setPorts] = useState([])
    const [endDate, setEndDate] = useState(null);
    const [showEndDate, setshowEndDate] = useState(true)
    const [departure, setDeparture] = useState("")
    const [arrival, setArrival] = useState("")
    const [showDeparturePort, setshowDeparturePort] = useState(true)
    const [showArrivalPort, setshowArrivalPort] = useState(true)
    const canApply =
        company &&
        dateFrom &&
        endDate &&
        departure &&
        arrival &&
        endDate >= dateFrom;








    React.useEffect(() => {

        getCompanies();





    }, []);


    const handleChange = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    const handleEndDate = (e) => {
        e.persist();
        setEndDate(e.target.value);
        if (company !== "" && typeof company !== 'undefined' && !showCompany) {
            setShowTrip(true);
            setDisableButton(true);
            setShowSpinner(false);
            getTrips(company, dateFrom, e.target.value);
        }
        else {
            setshowCompany(false);
        }
    }
    const handleDateFrom = (e) => {
        e.persist();
        setDateFrom(e.target.value);
        if (company !== "" && typeof company !== 'undefined' && !showCompany) {
            setShowTrip(true);
            setShowSpinner(false);
            setDisableButton(true);
            getTrips(company, e.target.value, endDate);
        }
        else {
            setshowEndDate(false);
        }
    }




    const setTypeCompany = (e) => {
        setDeparture("");
        setArrival("");
        setPorts([]);
        setshowArrivalPort(true);
        if (typeof (e.target.selectedIndex) !== 'undefined' && e.target.selectedIndex !== null) {
            setTimeout(() => {
                setCompany(companies[e.target.selectedIndex - 1]);
                // if(dateFrom!==null && companies[e.target.selectedIndex - 1] !=="" && departure !=="" && companies[e.target.selectedIndex - 1] !==undefined ){
                if (companies[e.target.selectedIndex - 1] !== "" && companies[e.target.selectedIndex - 1] !== undefined) {
                    let instance = UserClass.getInstance();
                    let token = instance.getTokenUser();
                    DataManager.getPorts(companies[e.target.selectedIndex - 1], token).then((result) => {
                        setPorts(result.ports.results)
                    })
                    setshowDeparturePort(false)

                }
                else {
                    setDisableButton(true);
                }
            }, 300);
        }
        e.preventDefault();
        e.stopPropagation();

    };

    const setTypeDeparture = (e) => {
        if (typeof (e.target.selectedIndex) !== 'undefined' && e.target.selectedIndex !== null) {
            setTimeout(() => {


                setDeparture(ports[e.target.selectedIndex - 1]);
                setArrival("");
                setshowArrivalPort(false);

            }, 300);
        }
        e.preventDefault();
        e.stopPropagation();

    }

    const setTypeArrival = (e) => {
        if (typeof (e.target.selectedIndex) !== 'undefined' && e.target.selectedIndex !== null) {
            setTimeout(() => {


                setArrival(ports[e.target.selectedIndex - 1]);


            }, 300);
        }
        e.preventDefault();
        e.stopPropagation();

    }


    const actionApply = () => {

        let tot = 0;
        setTotFilter(tot);

        if (
            company &&
            dateFrom &&
            endDate &&
            departure &&
            arrival &&
            endDate >= dateFrom
        ) {


            setShowModalFilter(false)
            setshowModalFilterRaceSummary(true)
            setDocument(null)

            let modeFile = "pdf";
            if (csvChecked == true) {
                modeFile = "csv";
            }
            let instance = UserClass.getInstance();

            let token = instance.getTokenUser();
            let departure_port = departure;
            let destination_port = arrival;
            let date_from = dateFrom;
            let date_to = endDate;
            DataManager.getReportItinerarioVessel(
                token,
                company,
                date_from,
                date_to,
                departure_port,
                destination_port,
                modeFile,
                selectedFilter
            ).then((result) => {
                if (typeof (result) !== 'undefined' && result !== null) {
                    if (typeof (result['report']) !== 'undefined' && result['report'] !== null) {
                        if (modeFile.toString() === "csv") {
                            const url = window.URL.createObjectURL(new Blob([result['report']]))
                            const link = document.createElement('a')
                            link.href = url;
                            const fileName = `report.csv`;
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            setshowModalFilterRaceSummary(false);

                        } else {
                            let blob = new Blob([result['report']], {
                                type: "application/pdf"
                            });
                            const url = window.URL.createObjectURL(blob);
                            setDocument(url);
                            setshowDocument(false);
                            setshowModalFilterRaceSummary(false);
                        }




                    } else {
                        setshowModalFilterRaceSummary(false);
                        if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
                            Functions.alertMsg(result['msgError']);
                        } else {
                            Functions.alertMsg(t("msgErrorGeneral"));
                        }
                    }
                } else {
                    setshowModalFilterRaceSummary(false);
                    Functions.alertMsg(t("msgErrorGeneral"));
                }
            })

            if (company !== "") {
                tot = tot + 1;

            }
            if (csvChecked || pdfChecked) {
                tot = tot + 1;
            }

            if (dateFrom != "") {
                tot = tot + 1;
            }

            if (endDate != "") {
                tot = tot + 1;
            }





            if (selectedFilter) {
                tot = tot + 1;
            }

            setTotFilter(tot)








        }
        else {
            if (endDate < dateFrom) {

                Functions.alertMsg(t("error_date"));
            }
            else {
                Functions.alertMsg("Company Field is required");

            }
        }
    };

    const getTrips = (company, dateFrom, endDate) => {
        let instance = UserClass.getInstance();
        let token = instance.getTokenUser();


        if (typeof (company) !== 'undefined' && company !== null && company !== "") {
            DataManager.getTrips(token, company, dateFrom, endDate).then((result) => {
                if (typeof (result) !== 'undefined' && result !== null) {
                    if (typeof (result['trips']) !== 'undefined' && result['trips'] !== null) {

                        setTrips(result['trips']['results'])
                        setShowTrip(false)
                        setShowSpinner(true)


                    } else {
                        setshowModalFilterRaceSummary(true);
                        if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
                            Functions.alertMsg(result['msgError']);
                        } else {
                            Functions.alertMsg(t("msgErrorGeneral"));
                        }
                    }
                } else {
                    setshowModalFilterRaceSummary(true);
                    Functions.alertMsg(t("msgErrorGeneral"));
                }
            });
        }
        else {
            setShowSpinner(true)
            setShowTrip(true)

        }
    }

    const getCompanies = () => {
        let instance = UserClass.getInstance();
        let token = instance.getTokenUser();

        DataManager.verifyLogin
            (token).then((result) => {
                if (typeof (result) !== 'undefined' && result !== null) {
                    if (typeof (result['verifylogin']) !== 'undefined' && result['verifylogin'] !== null) {

                        setCompanies(result['verifylogin']['companies'])
                    } else {
                        setshowModalFilterRaceSummary(true);
                        if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
                            Functions.alertMsg(result['msgError']);
                        } else {
                            Functions.alertMsg(t("msgErrorGeneral"));
                        }
                    }
                } else {
                    setshowModalFilterRaceSummary(true);
                    Functions.alertMsg(t("msgErrorGeneral"));
                }
            });
    }

    const actionReset = () => {
        setReset(true);
        /* let arr = {
             dateOfDay: dateOfDay,
             typologyReport: typologyReport,
             dateOfMonth: dateOfMonth
         };
         setArrFilter(arr);
         setDateOfDay("");
         setTypologyReport("");
         setDateOfMonth(null);*/
        setShowTrip(true)
        setCompany("")
        setDateFrom("")
        setpdfChecked(true)
        setcsvChecked(false)
        setshowCompany(true)
        setDisableButton(true)
        setTotFilter(0)
        setshowDocument(true);
        setEndDate("");
        setshowEndDate(true);
        setSelectedFilter('DEPARTUREDATE');
        setDeparture(""); 
        setArrival("");
        setshowArrivalPort(true);
        setshowDeparturePort(true);
        




    };

    const actionSelectFilter = () => {
        if (arrFilter !== null) {
            setDateOfDay(arrFilter.dateOfDay);
            setTypologyReport(arrFilter.typologyReport);
            setDateOfMonth(arrFilter.dateOfMonth);
            setReset(false);
        }
        setShowModalFilter(!showModalFilter);
    };







    const renderOption2 = (obj, idx) => {
        let check = false;
        if (typeof (company) !== 'undefined' && company !== null && company !== "") {
            if (company.toString() === obj) {
                check = true;
            }
        }
        return <option selected={check} key={idx}>{t(obj)}</option>
    };

    const renderOptionPortDeparture = (obj, idx) => {
        let check = false;
        if (typeof (departure) !== 'undefined' && departure !== null && departure !== "") {
            if (departure.toString() === obj) {
                check = true;
            }
        }
        return <option selected={check} key={idx}>{t(obj)}</option>
    };

    const renderOptionPortArrival = (obj, idx) => {
        let check = false;
        if (typeof (arrival) !== 'undefined' && arrival !== null && arrival !== "") {
            if (arrival.toString() === obj) {
                check = true;
            }
        }
        return <option selected={check} key={idx}>{t(obj)}</option>
    };

    return (
        <div>
            <div className={styles.ReportC2}>
                <Button
                    className="mb-3 ml-10"
                    onClick={actionSelectFilter}
                    title={t("filters")}
                >
                    <i className="fa-solid fa-filter side-menu__icon" /> {t("filters")} {totFilter > 0 ? <Badge bg="secondary">{totFilter.toString()}</Badge> : null}
                </Button>

                <Modal
                    {...props}
                    size="xs"
                    show={showModalFilterRaceSummary}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Body>{msgModalReport}</Modal.Body>
                    <Lottie options={defaultOptionsReport}
                        height={200} />
                </Modal>
                <Modal show={showModalFilter}>
                    <Modal.Header>
                        <Modal.Title>{t("filters")}</Modal.Title>
                        <Button onClick={actionSelectFilter}><i className="fa-solid fa-xmark" /></Button>
                    </Modal.Header>
                    <Modal.Body style={{
                        maxHeight: 'calc(100vh - 210px)',
                        overflowY: 'auto'
                    }}>
                        <Form>
                            <Form.Label>{t("file_format")}</Form.Label>

                            <Row>

                                <Col xl={6}>
                                    <Form.Group className="mb-3">

                                        <div className="mb-3">
                                            <Form.Check
                                                value="daily"
                                                type="radio"
                                                aria-label="radio 1"
                                                label={"PDF"}
                                                checked={pdfChecked}

                                                onChange={(e) => {
                                                    setpdfChecked(true);
                                                    setcsvChecked(false);

                                                }}
                                            />

                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col xl={6}>
                                    <Form.Group className="mb-3">
                                        <div className="mb-3">
                                            <Form.Check
                                                value="monthly"
                                                type="radio"
                                                aria-label="radio 2"
                                                label={"CSV"}
                                                checked={csvChecked}
                                                onChange={(e) => {
                                                    setpdfChecked(false);
                                                    setcsvChecked(true);

                                                }}
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <>
                                <Form.Label>{t("select_filter_type")}</Form.Label>
                                <Row>
                                    <Col xl={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                type="radio"
                                                label={t("departure_date")}
                                                value="DEPARTUREDATE"
                                                checked={selectedFilter === 'DEPARTUREDATE'}
                                                onChange={() => setSelectedFilter('DEPARTUREDATE')}
                                            />
                                        </Form.Group>
                                    </Col>
                                    {/*} <Col xl={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                type="radio"
                                                label={t("issue_date")}
                                                value="ISSUEDATE"
                                                checked={selectedFilter === 'ISSUEDATE'}
                                                onChange={() => setSelectedFilter('ISSUEDATE')}
                                            />
                                        </Form.Group>
                                    </Col> */}
                                    <Col xl={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                type="radio"
                                                label={t("boarding_date")}
                                                value="BOARDINGDATE"
                                                checked={selectedFilter === 'BOARDINGDATE'}
                                                onChange={() => setSelectedFilter('BOARDINGDATE')}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>

                            {/*<Row>
                                <Col xl={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("selectDay")}</Form.Label>
                                        <Form.Control onChange={(e) => {
                                            e.persist();

                                            setDateFrom(e.target.value);
                                            setCompany("")
                                            setshowCompany(false)

                                        }} type="date" value={dateFrom !== "" ? dateFrom : ""} />
                                    </Form.Group>
                                </Col>
                            </Row>*/}
                            <Row>
                                <Col xl={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("select_start_date")}</Form.Label>
                                        <Form.Control onChange={(e) => {
                                            handleDateFrom(e);
                                        }} type="date" value={dateFrom !== "" ? dateFrom : ""} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row hidden={showEndDate}>
                                <Col xl={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("select_end_date")}</Form.Label>
                                        <Form.Control onChange={(e) => {
                                            handleEndDate(e);
                                        }} type="date" value={endDate !== "" ? endDate : ""} min={dateFrom !== "" ? new Date(dateFrom).toISOString().split("T")[0] : null} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row hidden={showCompany}>
                                <Col xl={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("company")}</Form.Label>
                                        <Form.Select size="lg" onChange={(e) => setTypeCompany(e)}>
                                            <option key="value_null">-- {t("select")} --</option>
                                            {companies.map((item, idx) => (
                                                renderOption2(item, idx)
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Spinner hidden={showSpinner} animation="border" size="sm" />

                            <Row hidden={showDeparturePort}>
                                <Col xl={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("departure_port")}</Form.Label>
                                        <Form.Select size="lg" onChange={(e) => setTypeDeparture(e)}>
                                            <option key="value_null">-- {t("select")} --</option>
                                            {ports.map((item, idx) => (
                                                renderOptionPortDeparture(item, idx)

                                            ))}
                                        </Form.Select>

                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row hidden={showArrivalPort}>
                                <Col xl={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t("destination_port")}</Form.Label>
                                        <Form.Select size="lg" onChange={(e) => setTypeArrival(e)}>
                                            <option key="value_null">-- {t("select")} --</option>
                                            {ports.map((item, idx) => (
                                                renderOptionPortArrival(item, idx)

                                            ))}
                                        </Form.Select>

                                    </Form.Group>
                                </Col>
                            </Row>





                        </Form>
                    </Modal.Body>
                    {
                        typologyReport === "daily" ?
                            <Form style={{
                                marginLeft: '15px',
                                marginBottom: '10px',
                                marginTop: '-10px'
                            }}>
                                <Row>
                                    <Col xl={12}>
                                        <Form.Group className="mb-3">
                                            <p>{t("selectDay")}</p>
                                            <Form.Control style={{ width: "50%" }} onChange={(e) => {
                                                handleChange(e);
                                                setDateOfDay(e.target.value);
                                            }} type="date" value={dateOfDay !== "" ? dateOfDay : ""} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                            : null
                    }
                    {
                        typologyReport === "monthly" ?
                            <Form style={{
                                marginLeft: '15px',
                                marginBottom: '10px',
                                marginTop: '-10px'
                            }}>
                                <Row>
                                    <Col xl={12}>
                                        <p>{t("select_month_year")}</p>
                                        <DatePicker locale={it}
                                            selected={dateOfMonth === null ? new Date() : dateOfMonth}
                                            onChange={(date) => setDateOfMonth(date)}
                                            dateFormat="MM/yyyy"
                                            showMonthYearPicker
                                            showFullMonthYearPicker
                                            showTwoColumnMonthYearPicker />
                                    </Col>
                                </Row>
                            </Form>
                            : null
                    }
                    <Modal.Footer>
                        <Button variant="secondary" onClick={actionReset}>
                            {t("reset")}
                        </Button>
                        <Button
                            disabled={!canApply}
                            variant="primary"
                            onClick={actionApply}
                        >
                            {t("apply")}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Row hidden={showDocument}>

                    {

                        Document !== null ?
                            (

                                <Col xl={12}>
                                    <div className="pb-70">
                                        <Card>
                                            <Card.Body>
                                                <object width="100%" height="600"
                                                    data={Document}
                                                    type="application/pdf"></object>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </Col>


                            )
                            : null
                    }
                </Row>
            </div>
        </div>
    )
};

export default ReportItineraryVesselSummary;
